import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import usePageBackground from "../hooks/usePageBackground";
import { useTranslation } from 'react-i18next';
import Modal from "react-bootstrap/Modal";
import { MdOutlineMessage } from "react-icons/md";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import HTTPSCalls from "../Services/HttpCalls";
import { useLocation } from "react-router-dom";

const ContactSupport = forwardRef((props, ref) => {
  usePageBackground();
  const { t } = useTranslation();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);
  const location = useLocation();
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      issue_type: "",
      message: "",
      attachment: "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        // .matches(
        //   /^[A-Za-z]+(?: [A-Za-z]+)*$/,
        //   t('contactSupport.validation.nameLetters', 'Name should only contain letters')
        // )
        .required(t('contactSupport.validation.nameRequired', 'Name is required')),
        // .min(4, t('contactSupport.validation.nameMin', 'Minimum 4 characters')),
        // .max(10, t('contactSupport.validation.nameMax', 'Maximum 10 characters')),
      email: Yup.string()
        .email(t('contactSupport.validation.invalidEmail', 'Invalid email format'))
        .required(t('contactSupport.validation.emailRequired', 'Email is required')),
      issue_type: Yup.string().required(t('contactSupport.validation.issueTypeRequired', 'Please select an issue type')),
      message: Yup.string().required(t('contactSupport.validation.messageRequired', 'Message is required')),
      // attachment: Yup.mixed()
      //   .test("fileRequired", "Attachment is required", () => file !== null)
      //   .test("fileType", "Only JPG, JPEG, and PNG files are allowed", () =>
      //     file
      //       ? ["image/png", "image/jpeg", "image/jpg"].includes(file.type)
      //       : true
      //   )
      //   .test("fileSize", "File size must be less than 2MB", () =>
      //     file ? file.size <= 2 * 1024 * 1024 : true
      //   ),
    }),
    onSubmit: async (values) => {
      const formData = new FormData();
      // Append text fields except attachment
  Object.entries(values).forEach(([key, value]) => {
    if (key !== "attachment") {
      formData.append(key, value);
    }
  });

      // Append file (if selected)
      if (file) {
        formData.append("attachment", file);
      }
      try {
        const token = localStorage.getItem("token");
        const response = await HTTPSCalls.POST(
          `${apiUrl}${HTTPSCalls.EndPoints.ADD_CONTACTSUPPORT}`,
          {}, // No query params
          formData, // FormData
          { Authorization: `Bearer ${token}` } // Headers
        );

        //  console.log("Response:", response.data);
        formik.resetForm();
        setShow(false);
        setTimeout(() => {
          toast.success(
            response?.data?.message || t('contactSupport.toasts.success', 'Support request submitted successfully'),
            {
              toastId: "contact-support-success", // prevents duplicate
            }
          );
        }, 300);
      } catch (error) {
        // console.error("Error:", error.response?.data || error.message);
        toast.error(t('contactSupport.toasts.failed', 'Failed to submit support request.'));
      }
      // console.log("Contact Form Submitted:", values);
    },
  });

  // Expose openModal function to parent
  useImperativeHandle(ref, () => ({
    openModal: () => setShow(true),
  }));

  return (
    <>

      {location.pathname === "/signup" || location.pathname === "/contact-support" || location.pathname === "/wallet" ? null : (
        <>
          <div className="floating-button" onClick={() => setShow(true)}>
            <MdOutlineMessage />
          </div>
          <Modal
            show={show}
            backdrop="static"
            keyboard={false}
            centered
            onHide={() => {
              formik.resetForm();
              setShow(false);
            }}
          >
            <Modal.Header className="modal_custom_close  border-0">
              <i
                className="fa-solid fa-xmark close-modal"
                onClick={() => setShow(false)}
                style={{ cursor: "pointer" }}
              ></i>
              <h4 className="fw-bold text-blue">{t('contactSupport.title', 'Need Help? Contact Support')}</h4>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={formik.handleSubmit}>
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    placeholder={t('contactSupport.placeholders.name', 'Your Name')}
                    {...formik.getFieldProps("name")}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div style={{ color: "red" }}>{formik.errors.name}</div>
                  )}
                  <label htmlFor="name">{t('contactSupport.fields.name', 'Name')}</label>
                </div>

                <div className="form-floating mb-3">
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder={t('contactSupport.placeholders.email', 'Your Email')}
                    {...formik.getFieldProps("email")}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div style={{ color: "red" }}>{formik.errors.email}</div>
                  )}
                  <label htmlFor="email">{t('contactSupport.fields.email', 'Email')}</label>
                </div>

                <div className="mb-3">
                  <select
                    className="form-select"
                    id="issue_type"
                    name="issue_type"
                    {...formik.getFieldProps("issue_type")}
                  >
                    <option value="">{t('contactSupport.placeholders.selectIssueType', 'Select Issue Type')}</option>
                    <option value="general">{t('contactSupport.options.general', 'General Inquiry')}</option>
                    <option value="validation">{t('contactSupport.options.validation', 'Form Validation Issue')}</option>
                    <option value="upload">{t('contactSupport.options.upload', 'Unable to Upload Documents')}</option>
                    <option value="other">{t('common.other', 'Other')}</option>
                  </select>
                  {formik.errors.issue_type && formik.touched.issue_type ? (
                    <div style={{ color: "red" }}>
                      {formik.errors.issue_type}
                    </div>
                  ) : null}
                </div>

                <div className="form-floating mb-3">
                  <textarea
                    className="form-control"
                    id="message"
                    name="message"
                    placeholder={t('contactSupport.placeholders.message', 'Describe your issue...')}
                    style={{ height: "100px" }}
                    {...formik.getFieldProps("message")}
                  ></textarea>
                  {formik.touched.message && formik.errors.message && (
                    <div style={{ color: "red" }}>{formik.errors.message}</div>
                  )}
                  <label htmlFor="message">{t('contactSupport.fields.message', 'Message')}</label>
                </div>

                <div className="mb-3">
                  <label htmlFor="attachment" className="form-label">
                    {t('contactSupport.fields.attachmentOptional', 'Attach Screenshot (Optional)')}
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="attachment"
                    name="attachment"
                    accept=".png,.jpg,.jpeg"
                    onChange={(event) => {
                      const selectedFile = event.currentTarget.files[0];
                      setFile(selectedFile);
                      formik.setFieldValue("attachment", selectedFile);
                    }}
                  />
                  {formik.touched.attachment && formik.errors.attachment && (
                    <div style={{ color: "red" }}>
                      {formik.errors.attachment}
                    </div>
                  )}
                </div>

                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-brown "
                    type="button"
                    onClick={() => {
                      formik.resetForm();
                      setShow(false);
                    }}
                  >
                    {t('common.cancel')}
                  </button>
                  <button type="submit" className="btn btn-blue ms-2">
                    {t('contactSupport.actions.submitRequest', 'Submit Request')}
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
});

export default ContactSupport;
